/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const Header = () => {
  const [open, setOpen] = useState(false);
  const token = localStorage.getItem("token");
  const handlerToogle = () => {
    setOpen(!open);
  };
  const handlerLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("data");
    toast.success("Logout Successfully");
    window.location.href = "/";
  };

  return (
    <>
      <>
        <header className="header-area style-1">
          <div
            className="container-fluid d-flex justify-content-end align-items-center"
            style={{ marginTop: "20px" }}
          >
            <div className="header-logo">{/*  */}</div>
            <div className={`main-menu ${open ? "show-menu" : ""}`}>
              <div className="mobile-logo-area d-lg-none d-flex justify-content-between align-items-center">
                <div className="mobile-logo-wrap">
                  <Link to={"/"}>
                    <img
                      alt="image"
                      src="/assets/images/header.png"
                      style={{ width: "180px", height: "100px" }}
                    />
                  </Link>
                </div>
                <div className="menu-close-btn">
                  <i
                    className="bi bi-x-lg text-white"
                    onClick={handlerToogle}
                  />
                </div>
              </div>
              <ul className="menu-list">
                <li>
                  <Link to={"/"}>Home</Link>
                </li>
                <li>
                  <Link to={"/howit"}>How its Works</Link>
                </li>
                <li>
                  <Link to={"/about"}>About Us</Link>
                </li>
                <li>
                  <Link to={token ? "/subscription" : "/login"}>Subscription</Link>
                </li>
                {token ? (
                  <>
                    <li>
                      <Link to={`/profile`}>Profile</Link>
                    </li>
                    <li onClick={handlerLogout}>
                      <Link to={"/"}>Logout</Link>
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <Link to={`/signup`}>Register</Link>
                    </li>
                    <li>
                      <Link to={"/login"}>Login</Link>
                    </li>
                  </>
                )}
              </ul>
            </div>

            <div className="nav-right d-flex jsutify-content-end align-items-center">
              <ul className="main-menu" id="menu">
                <li className="search-btn">
                  {/*  */}
                  <form className="nav__search-form" style={{ width: "175px" }}>
                    <ul className="menu-list d-flex flex-column w-100 justify-content-center align-items-baseline">
                      {/*  */}
                    </ul>
                  </form>
                </li>
              </ul>
              <div className="sidebar-button mobile-menu-btn">
                <i className="bi bi-list" onClick={handlerToogle} />
              </div>
            </div>
          </div>
        </header>
      </>
    </>
  );
};

export default Header;
